import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com"; // Import emailjs
import "./style.css";
import Navbar from "../../Components/Navbar/index.tsx";
import Footer from "../../Components/Footer/index.tsx";
import avatar1 from "../../Assets/Career/avatar1.png";
import avatar2 from "../../Assets/Career/avatar2.png";
import avatar3 from "../../Assets/Career/avatar3.png";
import avatar4 from "../../Assets/Career/avatar4.png";
import avatar5 from "../../Assets/Career/avatar5.png";
import avatar6 from "../../Assets/Career/avatar6.png";
import Uploadcare from "uploadcare-widget";
import RatingCard from "../../Components/Review/index.tsx";
export default function Career() {
  const [resumeLink, setResumeLink] = useState(""); // Store the uploaded file's URL

  useEffect(() => {
    // Initialize Uploadcare widget on the element with role="uploadcare-uploader"
    const widget = Uploadcare.Widget("[role=uploadcare-uploader]");

    widget.onUploadComplete((info) => {
      // Store the file URL once upload is complete
      setResumeLink(info.cdnUrl);
    });
  }, []);

  const teamMembers = [
    { name: "Member 1", image: avatar1, top: "28%", left: "30%" },
    { name: "Member 3", image: avatar2, top: "55%", left: "15%" },
    { name: "Member 4", image: avatar4, bottom: "25%", right: "20%" },
    { name: "Member 5", image: avatar3, bottom: "26%", left: "39%" },
    { name: "Member 6", image: avatar5, top: "30%", right: "30%" },
    { name: "Member 7", image: avatar6, bottom: "51%", right: "10%" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    company: "",
    position: "",
    resume: resumeLink || "No resume uploaded",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      resume: e.target.files[0], // Handle the file input
    }));
  };

  const handleSubmit = () => {
    // Check if any required field is empty
    const { name, email, mobile, company, position } = formData;

    // Check if any required field is empty
    if (!name || !email || !mobile || !company || !position) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    // Log the form data to see if everything is correct
    // console.log("Form submitted:", formData);

    // Prepare the template params
    const templateParams = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      resume: resumeLink || "No resume uploaded",
      company: formData.company,
      position: formData.position,
    };

    // Send email using EmailJS
    emailjs
      .send(
        "service_7n9sofe", // Your EmailJS Service ID
        "template_qnotprp", // Your EmailJS Template ID
        templateParams, // Template Params
        "mEQV8ZfDnmzeWrxsh" // Your EmailJS User ID (Public Key)
      )
      .then(
        (result) => {
          // console.log("Email sent successfully:", result.text);
          alert("Your application has been submitted successfully!");
          setFormData({
            name: "",
            email: "",
            resume: "",
            mobile: "",
            company: "",
            position: "",
          });
        },
        (error) => {
          // console.error("Error sending email:", error.text);
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <>
      <Navbar />

      <section className="career-container">
        <div className="join-container">
          {teamMembers.map((member, index) => (
            <img
              key={index}
              src={member.image}
              alt={member.name}
              className="avatar"
              style={{
                top: member.top,
                left: member.left,
                right: member.right,
                bottom: member.bottom,
              }}
            />
          ))}

          <div className="join-content">
            <h2>Join our team!</h2>
            <p>
              Excited to learn, grow, and contribute? <br />
              We'd love to meet you!
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="career-form">
          <form>
            <div className="form-group">
              <label className="career-label" htmlFor="name">
                Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="contact-input"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="career-label" htmlFor="email">
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="contact-input"
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="career-label" htmlFor="mobile">
                Mobile <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="contact-input"
                type="tel"
                name="mobile"
                id="mobile"
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="career-label" htmlFor="position">
                Position <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="contact-input"
                name="position"
                id="position"
                value={formData.position}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="career-label" htmlFor="company">
                Recent Organization <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="contact-input"
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label
                className="career-label"
                htmlFor=""
                style={{ display: "block", marginBottom: "10px" }}
              >
                Upload Resume
              </label>
              <input
                name="resume"
                type="hidden"
                role="uploadcare-uploader"
                data-public-key="1f3b3abd66970ceec0c1"
                data-tabs="file"
              />
            </div>

            <div>
              <div
                onClick={() => {
                  handleSubmit();
                }}
                className="contact-submit"
              >
                <div className="svg-wrapper-1">
                  <div className="svg-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path
                        fill="currentColor"
                        d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                      ></path>
                    </svg>
                  </div>
                </div>
                <span>Submit</span>
              </div>
            </div>
          </form>
        </div>
      </section>
      <div style={{ backgroundColor: " 	#FFF5EE" }}>
        <RatingCard />
    
        <p className="rev-content">
          Want to know more about what our employees have to say? Hear directly
          from the people who make our company great. Their stories,
          experiences, and honest feedback speak volumes about our culture,
          values, and commitment to growth.
        </p>

        <div
          className="rev-btn"
          onClick={() =>
            (window.location.href =
              "https://www.google.com/search?client=firefox-b-d&sca_esv=02467373b682e586&sxsrf=AHTn8zr-JqrPcxaXfh3Ksj6NSIUec56few:1745915622017&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzbNYsi5_TQ6BLKfkwOhGsT1yBd8bVLpllh3owQiBnzDCNFFCw99QzuYkXjcvMRmZb8u1P2dQj4m1nE6mXxUvIkBiBajUS5__BeHRssAa5s4NoKItYcUnLH1tfNylV3EH3GJ065A%3D&q=Singapore+Security+Force+Pte+Ltd+Reviews&sa=X&ved=2ahUKEwj699TD6vyMAxWtaCoJHcQjADEQ0bkNegQIOhAE&biw=1760&bih=850&dpr=1.09")
          }
        >
          Click Here
        </div>
      </div>

      <Footer />
    </>
  );
}
